<template>
    <v-dialog
        :value="isOpen"
        width="350"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <slot name="title" />
            </v-card-title>
            <v-card-text>
                <v-row justify="center">
                    <v-col cols="auto">
                        <VueQRCodeComponent :text="text" />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    @click="onClose"
                >
                    Zamknij
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
 
<script>
import VueQRCodeComponent from 'vue-qrcode-component'

export default {
    name: 'QrCodeDialog',
    components: {
        VueQRCodeComponent
    },
    props: {
        isOpen: {
            type: Boolean
        },
        text: {
            type: String,
            default: null
        },
    },
    methods: {
        onClose() {
            this.$emit('close-qr-code-dialog')
        }
    }
}
</script>

